import { Box, Button, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { EkpTableProps, RowData } from "src/components/tables/ekp-table/commonTypes";
import { SenecEkpTheme } from "src/styles/ekp-theme/senecEkpTheme";
import { styled } from "src/styles/ekp-theme/ekpStyled";
import { FlyingCat } from "src/components/tables/ekp-table/FlyingCat";
import { Fragment } from "react";

export const EkpTableMobile = ({ noDataText, rows, filteredRows, loading, handleRowClick }: EkpTableProps) => {
    const theme: SenecEkpTheme = useTheme();

    return (
        <>
            <Stack width={"100%"} py={"4px"}>
                {loading ? (
                    <MobileLoadingRows />
                ) : (
                    <>
                        {filteredRows?.map((filteredRow, idx) => (
                            <StyledTableRowButton
                                key={idx}
                                disableRipple
                                onClick={() => handleRowClick && rows != null && handleRowClick(rows[idx])}
                                sx={{ py: "12px", px: "16px" }}
                            >
                                <Stack
                                    key={idx}
                                    spacing={1}
                                    sx={{
                                        flexDirection: "row",
                                        flexWrap: "wrap",
                                        width: "100%",
                                    }}
                                >
                                    {Object.entries(filteredRow as RowData).map((entry, id) => (
                                        <Fragment key={id}>
                                            {id === 0 ? (
                                                <Box width={"100%"}>
                                                    <Typography
                                                        variant="h4"
                                                        sx={{
                                                            color: theme.palette.senecPrimary.nightDarkGrey,
                                                            overflow: "hidden",
                                                            wordWrap: "break-word",
                                                            WebkitBoxOrient: "vertical",
                                                            WebkitLineClamp: 3,
                                                        }}
                                                    >
                                                        {entry[1].label ? entry[1].label : entry[1].value}
                                                    </Typography>
                                                </Box>
                                            ) : id === Object.keys(filteredRow).length - 1 ? (
                                                <Box
                                                    sx={{
                                                        marginLeft: "auto !important",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body1Responsive"
                                                        sx={{
                                                            overflow: "hidden",
                                                            wordWrap: "break-word",
                                                            WebkitBoxOrient: "vertical",
                                                            WebkitLineClamp: 2,
                                                            color: theme.palette.senecSecondary.neutralGray70,
                                                        }}
                                                    >
                                                        {entry[1].label ? entry[1].label : entry[1].value}
                                                    </Typography>
                                                </Box>
                                            ) : id === 1 ? (
                                                rowUndertitleSection(filteredRow, theme)
                                            ) : (
                                                <></>
                                            )}
                                        </Fragment>
                                    ))}
                                </Stack>
                            </StyledTableRowButton>
                        ))}
                        {/*EMPTY ROWS */}
                        {(!filteredRows || filteredRows.length === 0) && (
                            <Box px={2} py={"12px"} m={"auto"} width={"fit-content"}>
                                <Box width={"fit-content"} margin={"auto"}>
                                    <FlyingCat />
                                </Box>
                                <Box pt={3} maxWidth={"411px"}>
                                    <Typography variant={"h4"} align={"center"}>
                                        {noDataText}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                    </>
                )}
            </Stack>
        </>
    );
};

const rowUndertitleSection = (rowEntries: RowData, theme: SenecEkpTheme) => {
    const columns = Object.keys(rowEntries).length;
    const rowUndertitle = Object.entries(rowEntries as RowData)
        .filter((_, index) => index !== 0 && index !== columns - 1)
        .map((entry) => entry[1].label || entry[1].value)
        .join(" - ");

    return (
        <Box
            sx={{
                width: "80%",
            }}
        >
            <Typography
                variant="body1Responsive"
                sx={{
                    color: theme.palette.senecSecondary.neutralGray70,
                    wordBreak: "break-word",
                    mr: 1,
                }}
            >
                {rowUndertitle}
            </Typography>
        </Box>
    );
};

const MobileLoadingRows = () => {
    return (
        <>
            {Array(3)
                .fill(0)
                .map((row, idx) => (
                    <StyledTableRowButton key={idx} data-testid="mobile-row-loading" sx={{ py: "12px" }}>
                        <Stack key={idx} spacing={1} width={"100%"}>
                            <Stack>
                                <Typography>
                                    <Skeleton data-testid="mobile-skeleton" width="100%" />
                                </Typography>
                                <Box display={"inline-flex"} width={"100%"}>
                                    <Typography width={"80%"}>
                                        <Skeleton data-testid="mobile-skeleton" width="80%" />
                                    </Typography>
                                    <Typography width={"20%"}>
                                        <Skeleton data-testid="mobile-skeleton" width="100%" />
                                    </Typography>
                                </Box>
                            </Stack>
                        </Stack>
                    </StyledTableRowButton>
                ))}
        </>
    );
};

const StyledTableRowButton = styled(Button)(({ theme }: { theme: SenecEkpTheme }) => ({
    textDecoration: "none",
    color: "unset",
    textAlign: "unset",
    justifyContent: "flex-start",
    textTransform: "unset",
    borderRadius: "12px",
    "&:hover": {
        borderRadius: "12px",
        backgroundColor: theme.palette.senecSecondary.neutralGray000,
    },
}));
